import Message, { useTranslation } from 'maeng-utils/locale'
import React, { useMemo } from 'react'

type SkillSetItem = {
  label: string
  skills: string[]
}

const SkillSets = () => {
  const { t } = useTranslation()

  const skillSets = useMemo<SkillSetItem[]>(() => t('portfolio.skillSets.skills'), [t])

  return (
    <section className="mb-12">
      <Message
        i18nKey="portfolio.skillSets.title"
        className="text-3xl font-extrabold pt-5 pb-8"
        component="h2"
      />
      <div className="flex flex-col gap-10 mx-4">
        {skillSets.map(({ label, skills }) => (
          <div key={label} className="w-full">
            <h3 className="text-2xl font-bold mb-6 semi-highlight-[#ffaf19]">{label}</h3>
            <div className="grid grid-cols-3 gap-4 ml-6">
              {skills.map((skill) => (
                <span className="text-lg" key={skill}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default SkillSets
